const ENABLED_CATEGORY_IDS = [51163, 51164];

const shouldShowModal = ({
  categoryId,
  loyaltyIsEnabled,
  loyaltyIsInvited,
  loyaltyIsOptedIn
}) =>
  loyaltyIsEnabled &&
  ENABLED_CATEGORY_IDS.includes(categoryId) &&
  loyaltyIsInvited &&
  !loyaltyIsOptedIn;

export default shouldShowModal;
